import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'
import PropTypes from 'prop-types'

import { IconRefresh } from '../assets/icons'
import SVGWrapper from './SVGWrapper'

// Shared between the desktop footer and mobile top nav. The caller controls
// the icon color because each placement uses a different theme color.
const Control = styled.button`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  column-gap: 5px;
  padding: 0;
  border: none;
  background: none;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
  color: ${p => p.theme.mediumGray ?? '#4a606a'};
  text-decoration: underline;

  /* SVGWrapper uses inline-block, whose baseline space shifts the icon above the
     label. Flex layout removes that baseline alignment and centers the icon. */
  & > div {
    display: flex;
    align-items: center;
  }
`

const AdviceUndoControl = ({ onClick, label = 'Undo changes', iconColor, className }) => {
  const theme = useTheme()

  return (
    <Control type='button' onClick={onClick} className={className}>
      <SVGWrapper
        svg={IconRefresh}
        fill={iconColor ?? theme.primaryColor ?? '#038ab7'}
        size='large'
        cursor='pointer'
      />
      {label}
    </Control>
  )
}

AdviceUndoControl.propTypes = {
  onClick: PropTypes.func.isRequired,
  /** Defaults to "Undo changes." */
  label: PropTypes.string,
  /** Defaults to the theme's primary color. */
  iconColor: PropTypes.string,
  className: PropTypes.string,
}

export default AdviceUndoControl
